
import { FrontendStoreLocator } from "@/interfaces";
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";

export default defineComponent({
  name: "StoreLocatorResult",
  props: {
    dirty: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();

    const selectedStoreLocator = computed<FrontendStoreLocator | null>(() => {
      return store.state.selectedStoreLocator;
    });

    const showResults = computed(() => {
      return props.dirty && store.state.countStoreLocators >= 0;
    });

    const hasProvince = computed(() => {
      return store.getters.hasProvince;
    });

    const storeLocators = computed(() => {
      return store.state.storeLocators;
    });

    const onSelect = (el: FrontendStoreLocator) => {
      store.commit("setStoreLocator", {
        storeLocator: el,
        move: false,
      });
    };

    return {
      showResults,
      hasProvince,
      storeLocators,
      selectedStoreLocator,
      FaMapMarker: faMapMarker,
      onSelect,
    };
  },
});
